<template>
  <el-drawer
    class="sideDrawer"
    :size="drawerSize"
    :close-on-click-modal="false"
    destroy-on-close
    :title="isEdit?'编辑订单':'新增订单'"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    append-to-body
  > <i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    
    <div
      class="form_content"
      style="padding: 20px"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row class="form_head_title">
          
          客户信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="订单编号:"
              prop="order_no"
            >
              <el-input
                v-model="formData.order_no"
                placeholder="保存后自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="订单日期:"
              prop="order_time"
            >
              <el-date-picker
              style="width:100%"
                v-model="formData.order_time"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="客户名称:"
              prop="customer_name"
            >
              <el-select
              style="width:100%"
                filterable
                v-model="formData.customer_name"
                placeholder="请选择"
                v-if="tenantId == '-1'"
                @change="customerChange"
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <el-input
                v-model="formData.customer_name"
                disabled
                v-else
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="创建人:"
              prop="create_user"
            >
              <el-input
                v-model="formData.create_user"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人:"
              prop="contacts"
            >
              <el-input v-model="formData.contacts"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话:"
              prop="contacts_phone"
            >
              <el-input v-model="formData.contacts_phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">
          
          订单信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="产品名称:"
              prop="account_name"
            >
              <el-select
              style="width:100%"
                v-model="formData.account_name"
                placeholder="请选择"
                @change="accountChange"
                :disabled="!isCanChange"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="目前状态:"
              prop="account_status"
            >
              <el-select
                v-model="formData.account_status"
                placeholder="请选择"
              style="width:100%"
                disabled
              >
                <el-option
                  v-for="item in cellStatusList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="套餐名称:"
              prop="contacts_package"
            >
              <el-select
                v-model="formData.contacts_package"
              style="width:100%"
                placeholder="请选择"
                @change="comboChange"
              >
                <el-option
                  v-for="item in comboList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="订单金额:"
              prop="order_amount"
            >
              <form-input
                :numberVal="formData.order_amount"
                :disabled="tenantId != '-1'"
                @setVal="setVal"
                :keyName="'order_amount'"
              ></form-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="充值时间(年):"
              prop="recharge_years"
            >
              <form-input
                :numberVal="formData.recharge_years"
                :disabled="tenantId != '-1'"
                @setVal="setVal"
                :keyName="'recharge_years'"
              ></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="购买用户数:"
              prop="users_number"
            >
              <form-input
                :numberVal="formData.users_number"
                :disabled="tenantId != '-1'"
                @setVal="setVal"
                :keyName="'users_number'"
              ></form-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="购买次数(次):"
              prop="purchases_number"
            >
              <form-input
                :numberVal="formData.purchases_number"
                :disabled="tenantId != '-1'"
                @setVal="setVal"
                :keyName="'purchases_number'"
              ></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="备注:"
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            type="textarea"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button
        size="small"
        @click="beforeCloseDialog"
      >取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        v-loading="loading"
      >保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import * as constants from './constants'
import FormInput from './formInput.vue'
export default {
  components: { FormInput },
  data() {
    return {
      drawerSize: '70%',
      formData: {
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0,
        showInput: false,
        showNum: true
      },
      rules: {
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        account_name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        contacts_package: [{ required: true, message: '请选择产品套餐', trigger: 'blur' }],
        contacts_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        order_amount: [
          { required: true, message: '请输入订单金额', trigger: 'blur' },
          {
            pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
            message: '订单金额必须大于0',
            trigger: 'blur'
          }
        ]
      },
      ...constants,
      accountList: [],
      comboList: [],
      accountStatus: [],
      isClear: true,
      isCanChange: true,
      loading: false
    }
  },

  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    isView: {
      type: Boolean,
      default: () => false
    },
    tenantId: {
      type: String,
      default: () => ''
    },
    tenantName: {
      type: String,
      default: () => ''
    },
    orderId: {
      type: String,
      default: () => ''
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    tempValue: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    'formData.customer_id': {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal != '' && newVal != oldVal) {
          this.getStatus(newVal)
        }
      }
    },
    'formData.account_key': {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal != '' && newVal != oldVal) {
          this.getCombo(newVal)
          if (this.isClear) {
            this.formData.contacts_package = ''
          }
          let indexs = newVal
          this.accountStatus.forEach((item) => {
            if (item.account_module == indexs) {
              if (this.isEnough(item)) {
                this.formData.account_status = 0
              } else if (this.isArrears(item)) {
                this.formData.account_status = 2
              } else {
                this.formData.account_status = 1
              }
            }
          })
        }
      }
    },
    show: {
      handler(newVal, oldVal) {
        if (newVal) this.initData()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      if (!this.isEdit) {
        this.formData.order_time = utils.formatDate(new Date())
        this.formData.create_user = this.$store.state.login.currentUser.username
        this.formData.create_user_id = this.$store.state.login.currentUser.userId
        this.formData.customer_name = sessionStorage.tenantName
        this.formData.customer_id = sessionStorage.currentTenantId
      }
      if (this.orderId) {
        this.isClear = false
        this.$http.get('${third}/costcenter/third_order/' + this.orderId).then((res) => {
          if (res.data) {
            this.formData = res.data
            setTimeout(() => {
              this.isClear = true
            }, 1000)
          }
        })
      }
      // 传入tempValue
      if (this.tempValue && this.tempValue.account_module) {
        this.isCanChange = false
        let temp = this.typeList.find((item) => item.code == this.tempValue.account_module)
        if (temp) {
          this.formData.account_name = temp.name
          this.formData.account_key = temp.code
          this.formData.customer_name = this.tenantName
          this.formData.customer_id = this.tenantId
        }
      }
      if (this.tenantId == '-1') {
        this.accountList = []
        let params = {
          pageBean: {
            page: 1,
            pageSize: 500,
            total: 0
          },
          querys: [
            {
              group: 'advance',
              value: 'enable',
              relation: 'AND',
              operation: 'EQUAL',
              property: 'status'
            }
          ]
        }
        this.$http.post('${uc}/uc/tenantManage/v1/listJson', params).then((res) => {
          if (res.data) {
            res.data.rows.forEach((item) => {
              this.accountList.push({
                name: item.name,
                code: item.id
              })
            })
          }
        })
      }
      if (this.tenantId != '-1') {
        this.getStatus(this.tenantId)
      }
    },
    //千分位组件值回写
    setVal(keyName, val) {
      this.formData[keyName] = val
    },
    // 是否余额不足
    isEnough(module) {
      let enDays = module.remainDays < 30 && module.remainDays > 0
      let enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 30 && module['total_user'] - module['userCount'] > 0
      let enTimes =
        module.total_times !== null && module['total_recharge'] - module['total_times'] < 100 && module['total_recharge'] - module['total_times'] > 0
      return enDays || enUser || enTimes
    },
    // 是否欠费
    isArrears(module) {
      let enDays = module.remainDays < 1
      let enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 1
      let enTimes = module.total_times !== null && module['total_recharge'] - module['total_times'] < 1
      return enDays || enUser || enTimes
    },
    //根据产品查询套餐内容
    getCombo(types) {
      this.comboList = []
      this.$http.get('${third}/account/third_combo/getComboByAccountModule/' + types + '?tenantId=-1').then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.comboList.push({
              name: item.combo_name,
              code: item.id,
              price: item.price,
              times: item.times,
              user_num: item.user_num,
              year: item.year
            })
          })
        }
      })
    },
    //获取产品状态
    getStatus(id) {
      this.$http.get('${third}/system/account_mangement/getById?tenantId=' + id).then((res) => {
        if (res.data) {
          this.accountStatus = res.data
          if (this.formData.account_key) {
            let indexs = this.formData.account_key
            this.accountStatus.forEach((item) => {
              if (item.account_module == indexs) {
                if (item.account_module == indexs) {
                  if (this.isEnough(item)) {
                    this.formData.account_status = 0
                  } else if (this.isArrears(item)) {
                    this.formData.account_status = 2
                  } else {
                    this.formData.account_status = 1
                  }
                }
              }
            })
          }
        }
      })
    },
    //关闭dialog
    beforeCloseDialog() {
      this.$emit('closeInsert')
    },
    //客户选择器同时绑定客户id
    customerChange(val) {
      this.accountList.forEach((item) => {
        if (item.name == val) {
          this.formData.customer_id = item.code
        }
      })
    },
    //产品名称数据绑定
    accountChange(val) {
      this.typeList.forEach((item) => {
        if (item.name == val) {
          this.formData.account_key = item.code
        }
      })
    },
    //套餐选择内容绑定
    comboChange(val) {
      this.comboList.forEach((item) => {
        if (item.name == val) {
          this.formData.recharge_years = item.year
          this.formData.users_number = item.user_num
          this.formData.purchases_number = item.times
          this.formData.package_id = item.code
          this.formData.order_amount = item.price
        }
      })
    },
    //提交数据
    submit() {
      this.loading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.isEdit) {
            this.$http.post('${third}/costcenter/third_order/', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closeInsert')
                this.$message.info('订单新增成功！')
              }
            })
          } else {
            this.$http.put('${third}/costcenter/third_order/', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closeInsert')
                this.$message.info('订单保存成功！')
              }
            })
          }
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
</style>
